'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../util/interfaces.js');
require('../util/user.constants.js');
var normalize = require('../util/normalize.js');
require('../util/date.js');
require('../util/static-content.js');
var index = require('../adapter/index.js');

class Loyalty {
  userProgress(params) {
    return index.adapter.loyalty.userProgress(params);
  }
  history() {
    return index.adapter.loyalty.history();
  }
  rank(params) {
    return index.adapter.loyalty.rank(params).then(normalize.normalize);
  }
}
const loyalty = new Loyalty();

exports.loyalty = loyalty;
